module.exports = __webpack_public_path__ + "images/logo-white-d6614f75c3f41a37d5c13f1330849022.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/logo-white.png
// module id = UQL9
// module chunks = 0